import { SxProps, Theme } from '@mui/material';

export const FooterStyles: SxProps<Theme> = (theme) => ({
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    backgroundColor: theme.palette.grey[50],
});

export const PaddingStyles: SxProps = {
    padding: '10px 24px 24px 24px',
};

export const MarginStyles: SxProps = {
    margin: '32px 0px',
};
